export default {
  state: {
    url: null,
    year: null,
    baseYear: null
  },
  getters: {
    url: (state) => state.url,
    year: (state) => state.year,
    baseYear: (state) => state.baseYear
  }
}
